// extracted by mini-css-extract-plugin
module.exports = {"layout":"Layout_layout__3-CHP","controller":"Layout_controller__2tzXd"};